import ApiError from './ApiError.vue';
import { apiClient } from './client';
import useToastError from './useToastError';
import useToastErrorImperative from './useToastErrorImperative';

export const getClientActivityAreas = () => {
  return apiClient.get('/merchant/core/clients/clients/questionnaire/activity-areas');
};

export const getPassportIssuers = () => {
  return apiClient.get('/merchant/core/info/passport-issuers');
};

export const getCreditsApp = () => {
  return apiClient.get('/merchant/credit/credits/app');
};

export const getWarehouseApp = () => {
  return apiClient.get('/merchant/warehouse/app');
};

export const getDeliveriesApp = () => {
  return apiClient.get('/merchant/delivery/deliveries/app');
};

// TODO: remove this route
export const getThirdCategory = params => {
  return apiClient.get(`/merchant/shop-dotnet/categories/third-levels`, { params });
};

export const getOrderStatuses = params => {
  return apiClient.get(`/merchant/shop-dotnet/orders/statuses`, { params });
};

export const getDeliveryApp = () => {
  return apiClient.get('/merchant/delivery/deliveries/app');
};

export { apiClient, ApiError, useToastError, useToastErrorImperative };
